{
    "id": "1",
    "board": "Info",
    "title": "Bug Catcher- report issues here! ",
    "author": "madmod",
    "replies": 8,
    "posts": [
        {
            "user": "madmod",
            "body": "Please report any issues with the forum in this thread."
        },
        {
            "user": "rat",
            "body": "> Please report any issues with the forum in this thread.\n\n\nI do not like this thread"
        },
        {
            "user": "weeb",
            "body": "i miss dingo :(((( unban him pwease"
        },
        {
            "user": "scotty",
            "body": "on my way home from school I saw caterpillr :)"
        },
        {
            "user": "madmod",
            "body": "> i miss dingo :(((( unban him pwease\n\nWe don't unban people here. If he wants to roleplay as a lesbian, he's going to have to do it somewhere else. It's not that hard to be normal!"
        },
        {
            "user": "weeb",
            "body": "\n> We don't unban people here. If he wants to roleplay as a lesbian, he's going to have to do it somewhere else. It's not that hard to be normal!\n\nBAKA.... （￣～￣;）"
        },
        {
            "user": "egg",
            "body": "> on my way home from school I saw caterpillr 🙂\n*Squish*"
        },
        {
            "user": "scotty",
            "body": "D:"
        }
    ]
}